import { InputFillType, InputProperty, InputType } from '../enums';
import { StyleColorSchemeType } from '../../../../../../styles/enums';
import {
  INPUT_DEFAULT_MIN_LENGTH,
  INPUT_DEFAULT_MAX_LENGTH,
  INPUT_DEFAULT_MIN_NUMBER,
  INPUT_DEFAULT_MAX_NUMBER,
  INPUT_DEFAULT_STEP,
} from '../constants';

const InputProps = {
  props: {
    [InputProperty.Value]: {
      default: '',
      type: [String, Number],
    },
    [InputProperty.Name]: {
      default: '',
      type: String,
    },
    [InputProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [InputProperty.Placeholder]: {
      default: '',
      type: String,
    },
    [InputProperty.Label]: {
      default: '',
      type: String,
    },
    [InputProperty.Type]: {
      default: InputType.Text,
      type: String,
    },
    [InputProperty.MinLength]: {
      default: INPUT_DEFAULT_MIN_LENGTH,
      type: Number,
    },
    [InputProperty.MaxLength]: {
      default: INPUT_DEFAULT_MAX_LENGTH,
      type: Number,
    },
    [InputProperty.MinNumber]: {
      default: INPUT_DEFAULT_MIN_NUMBER,
      type: Number,
    },
    [InputProperty.MaxNumber]: {
      default: INPUT_DEFAULT_MAX_NUMBER,
      type: Number,
    },
    [InputProperty.Step]: {
      default: INPUT_DEFAULT_STEP,
      type: Number,
    },
    [InputProperty.IsReadonly]: {
      default: false,
      type: Boolean,
    },
    [InputProperty.AreaLabel]: {
      default: '',
      type: String,
    },
    [InputProperty.FillType]: {
      default: InputFillType.Outlined,
      type: String,
    },
    [InputProperty.ColorScheme]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [InputProperty.IsLoading]: {
      default: false,
      type: Boolean,
    },
  },
};

export default InputProps;
